module.exports = __webpack_public_path__ + "static/media/xerath.0f7e2b1d.png";